export const GO_TO_WALLET_URL = '/wallet/balance'
export const MY_ORDERS_URL = '/my_orders?order_type=sold'
export const WALLET_SETUP_URL = '/wallet/setup'
export const WALLET_PAYOUT_URL = '/wallet/payouts/new'
export const USER_FAVOURITE_ITEMS_URL = '/member/items/favourite_list'
export const YEARLY_INCOME_REPORT_URL = (year: number) => `/wallet/income_reports/${year}.pdf`
export const INVOICE_URL = (invoiceId: number) => `/wallet/invoices/${invoiceId}`
export const WALLET_INVOICES_URL = '/wallet/invoices'
export const WALLET_HISTORY_PATH = '/wallet/history'
export const WALLET_HISTORY_OVERVIEW_URL = '/wallet/history/overview'
export const WALLET_INCOME_REPORTS_URL = '/wallet/income_reports'
